module.exports = __webpack_public_path__ + "media/images/emoticons/lovely-e2c37c82dad93416a6e35b2cdb5b4ce9.gif";